/**
 * Created by bartdecorte on 27/04/2017.
 */
import Page from '../Page';
import DirtyUnloadNotifier from '../../utils/DirtyUnloadNotifier';
import EntriesDetail from './_partials/EntriesDetail';
import SubmitButtonManager from '../../helpers/SubmitButtonManager';

class EntriesEdit extends Page {
  constructor() {
    super();
    this.$entries = $('.js-entries').first();
    this.$form = this.$entries.parents('form').first();
    this.dirtyUnloadNotifier = new DirtyUnloadNotifier(
      '.js-dirty-unload-notify'
    );
    this.entriesDetail = new EntriesDetail({
      $root: this.$entries,
      dirtyUnloadNotifier: this.dirtyUnloadNotifier,
    });
    this.submitButtonManager = new SubmitButtonManager({
      buttonSelector: '.js-btn-save, .js-btn-save-return',
      $form: this.$form,
      stateEmitter: this.entriesDetail,
      onActualSubmit: () => {
        this.submitForm();
      },
    });
    this.bindKeys(this.keyBindings());
  }

  keyBindings() {
    const bindings = super.keyBindings();
    const scope = this;
    return {
      ...bindings,
      'mod+s': (ev) => scope.lModS(ev),
    };
  }

  lModS(ev) {
    if (ev.preventDefault) {
      ev.preventDefault();
    }
    this.submitButtonManager.submitWhenIdle('save');
    return false;
  }

  submitForm() {
    this.dirtyUnloadNotifier.lFormSubmitted();
    const form = this.$form.get(0);

    // Event needs to actually be triggered to make CKeditor write to the textarea, does not submit the form
    form.dispatchEvent(new Event('submit'));

    // This makes the submit happen
    document.createElement('form').submit.call(form);
  }
}

export default EntriesEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Entries/EntriesEdit.js